import data from '@emoji-mart/data';
import { init } from 'emoji-mart';

// In order to use emoji search directly (vs through a component), we need to initialize the emoji
// data somewhere in the configuration of our app. This has the added benefit of not having to pass
// the data to the emoji display component directly.
export default function configureEmojis() {
  init({ data });
}
